/* eslint-disable import/prefer-default-export */
export const DEFAULT_ERROR_MESSAGE =
  'Service error, pelase contact the dev team in #dev-bug-report';
